<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
    ref="currentDiagnosis"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit">
        אבחנה נוכחית לפעולה (באנגלית)
        <span class="only-doc-fill flex">
          <img src="/assets/img/svg/doctor-fill.svg" />
          למילוי ע״י הרופא
        </span>
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>

    <div v-show="isOpen" class="book_surgery_open toggleInner">
      <div class="no_mobile surg_list_head desk-flex">
        <div class="surg_list-1">צד</div>
        <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
        <div class="surg_list-3">קוד אבחנה</div>
        <div class="surg_list-5">הערות</div>
      </div>
      <CurrentDiagnosisInfo
        :rows="surgery.current_diagnosis"
        @editSelectedBlock="editSelectedBlock"
        @removeSelectedBlock="removeSelectedBlock"
      />
      <div
        class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
      >
        <div class="add_new_row flex surg_list-1">
          <div class="add_new_row_col1 desk-hide">צד</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <select2 name="" dir="rtl" v-model="diagnosis_info.side">
                <option value="">בחר צד</option>
                <option value="Right">Right</option>
                <option value="BIL">BIL</option>
                <option value="Left">Left</option>
              </select2>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">
            שם אבחנה*
            <span class="note block">ניתן לחפש לפי קוד</span>
          </div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block relative">
              <div
                v-show="diagnosis_info.name !== ''"
                @click="diagnosis_info.name = ''"
                class="surg-clear-btn"
                :class="{ 'btn-mobile': isMobile }"
              >
                X
              </div>
              <multiselect
                placeholder=""
                v-model="diagnosis_info.name"
                @search-change="onSearch"
                @close="onSearch('')"
                :options="filteredTypeheadOptions"
                :searchable="true"
                :internal-search="false"
                :allow-empty="false"
                :options-limit="limit"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <input disabled v-model="diagnosis_info.code" />
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-5">
          <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
          <div class="input_area_opcity">
            <textarea
              v-model="diagnosis_info.notes"
              placeholder="פירוט..."
              autocomplete="off"
            ></textarea>
          </div>
        </div>
        <ActionsMsgRow
          :errMsg="{ show: showErrorMessage, msg: errorMessage }"
          :isOnEdit="diagnosis_info_edit"
          @addBlock="addBlock"
          @removeSelectedBlock="resetRow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import CurrentDiagnosisInfo from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/info/CurrentDiagnosisInfo.vue";
import ActionsMsgRow from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/ActionsMsgRow.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import typeheadSearch from "@/mixins/typehead-search.js";
import { DEFAULT_OPTIONS_LIMIT } from "@/utilities/typehead-search.js";

// Constants
const MOBILE_BREAKPOINT = 1200;

/**
 * CurrentDiagnosis Component
 * Handles the current diagnosis section for surgery (in English)
 * For doctor's use only
 */
export default {
  name: "CurrentDiagnosis",
  components: {
    CurrentDiagnosisInfo,
    ActionsMsgRow,
    Multiselect
  },
  mixins: [typeheadSearch],
  data() {
    return {
      isOpen: false,
      isMobile: window.innerWidth < MOBILE_BREAKPOINT,
      // Typeahead options for diagnosis
      current_diagnosis: [],
      doctorHistory: null,
      // Current diagnosis form data
      diagnosis_info: {
        side: "",
        code: "",
        name: "",
        notes: ""
      },
      // Error messages
      errorMessage: "יש למלא את כל השדות",
      showErrorMessage: false,
      // Edit state
      diagnosis_info_edit: false,
      editRow: null
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      isEditMode: state => state.isEditMode
    }),
    ...mapGetters(["activeDoctor"]),

    /** Full options list searched by the typehead mixin */
    typeheadOptions() {
      return this.current_diagnosis;
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY"]),

    /**
     * Moves a diagnosis row into edit mode
     */
    editSelectedBlock(index) {
      this.editRow = index;
      const object = { ...this.surgery.current_diagnosis[index] };
      const updatedDiagnosis = [...this.surgery.current_diagnosis];
      updatedDiagnosis.splice(index, 1);
      this.SET_SURGERY({ current_diagnosis: updatedDiagnosis });
      this.diagnosis_info = object;
      this.diagnosis_info_edit = true;
    },

    /**
     * Removes a diagnosis row from the list
     */
    removeSelectedBlock(index) {
      // Adjust edit index if removing a row before the currently edited row
      if (this.editRow !== null && index < this.editRow) {
        this.editRow--;
      }
      const updatedDiagnosis = [...this.surgery.current_diagnosis];
      updatedDiagnosis.splice(index, 1);
      this.SET_SURGERY({ current_diagnosis: updatedDiagnosis });
    },

    /**
     * Validates diagnosis data has required fields
     */
    validateObjectData(object) {
      return Boolean(object.name);
    },

    /**
     * Shows/hides the error message
     * Called from parent component during validation
     */
    setError(show) {
      this.showErrorMessage = show;
      if (show) this.isOpen = true;
    },

    /**
     * Validates and adds the current diagnosis to the list
     */
    addBlock() {
      const isAddFromEdit = this.editRow !== null;
      this.showErrorMessage = false;
      this.diagnosis_info_edit = false;

      const object = { ...this.diagnosis_info };
      if (!this.validateObjectData(object)) {
        this.showErrorMessage = true;
        if (isAddFromEdit) this.editRow = null;
        return;
      }

      // Deep clone to avoid mutating store directly
      const updated = this.surgery.current_diagnosis.map(d => ({ ...d }));

      if (isAddFromEdit && this.editRow !== null) {
        updated.splice(this.editRow, 0, object);
      } else {
        updated.push(object);
      }

      this.SET_SURGERY({ current_diagnosis: updated });
      this.clearForm();
      if (isAddFromEdit) this.editRow = null;
    },

    /**
     * Clears all fields in the diagnosis form
     */
    clearForm() {
      Object.keys(this.diagnosis_info).forEach(key => {
        this.diagnosis_info[key] = "";
      });
    },

    /**
     * Resets the form
     */
    resetRow() {
      this.clearForm();
      this.diagnosis_info_edit = false;
    },

    /**
     * Returns the typeahead limit based on doctor's history
     */
    limitTypehead() {
      const history = this.doctorHistory?.current_diagnosis;
      return history?.length || DEFAULT_OPTIONS_LIMIT;
    },

    /**
     * Prepends doctor's history items to the typeahead options
     */
    getTypeheadHistory(resArr) {
      const history = this.doctorHistory?.current_diagnosis;
      if (!history?.length) return resArr;
      return [...history, ...resArr];
    },

    /**
     * Fetches doctor's diagnosis history and populates typeahead options
     */
    async getHistory() {
      if (!this.activeDoctor?.id) return;

      try {
        const resHistory = await this.$API.getDoctorHistory(
          this.activeDoctor.id
        );
        if (resHistory) this.doctorHistory = resHistory;

        // Fetch typeahead options
        const diagnosisRes = await this.$API.getTypehead(
          "current_new_diagnosis"
        );

        // Process diagnosis options
        const diagnosisTmp = diagnosisRes.map(r => r.diagnosis);
        this.current_diagnosis = [
          ...new Set(this.getTypeheadHistory(diagnosisTmp))
        ];
      } catch (error) {
        console.error("Failed to fetch doctor history:", error);
      }
    }
  },
  watch: {
    activeDoctor: {
      handler() {
        this.getHistory();
      },
      immediate: true
    },

    /**
     * Auto-fill diagnosis code from name
     */
    "diagnosis_info.name"(val) {
      this.diagnosis_info.code = val.substring(0, val.indexOf(" "));
    }
  },
  mounted() {
    // Open section if current_diagnosis has content in edit mode
    if (this.isEditMode && this.surgery.current_diagnosis?.length) {
      this.isOpen = true;
    }
  }
};
</script>
